/** 検索文字列を前後空白除去・NFKC・日本語ロケール小文字へ正規化する。 */
export function normalizeSearchText(value: string): string {
  return value.trim().normalize('NFKC').toLocaleLowerCase('ja-JP')
}
